
// import router from "@/router";
import { defineComponent, reactive, toRefs, onMounted, ref } from "vue";
import { httpChannelSelectList, httpChannelCommissionMerchantList } from "@/api/DistributionManagement/ChannelManagement";
import { httpOrderExport, httpOrderList } from "@/api/DistributionManagement/DistributionOrders";
import { ElMessage } from "element-plus";
import fTime from "@/utils/fTime"; //时间转换
import { useRoute } from "vue-router";
export default defineComponent({
  name: "examine",
  setup() {
    let data = reactive<any>({
      // 头部数据展示
      aHeader: [
        {
          icon: "/compontsimg/数量.png",
          cont: "新增会员人数：",
          text: 0,
        },
        {
          icon: "/compontsimg/金额.png",
          cont: "渠道分佣合计：￥",
          text: 0,
        },
        {
          icon: "/compontsimg/金额2.png",
          cont: "繁星分佣合计：￥",
          text: 0,
        },
      ],
      // 头部查询
      formList: [
        {
          label: "卡订单号",
          key: "orderNo",
          type: "input",
          placeholder: "请输入卡订单号",
          clearable: true,
        },
        {
          label: "分销渠道",
          key: "channelId",
          type: "select",
          placeholder: "请选择",
          clearable: true,
          optionList: [],
        },
        {
          label: "连锁商户",
          key: "merchantId",
          type: "select",
          placeholder: "请选择",
          clearable: true,
          optionList: [],
        },
        {
          label: "卡状态",
          key: "orderStatus",
          type: "select",
          placeholder: "请选择",
          clearable: true,
          optionList: [
            { label: "生效中", value: "01" },
            { label: "已退款", value: "02" },
            { label: "过期", value: "03" },
          ],
        },
        {
          slotName: "payTime",
        },
      ],
      formData: { orderNo: "", channelId: null, merchantId: "", orderStatus: "", payTime: [] },

      // 分销渠道列表下拉框请求
      getSelection: () => {
        httpChannelSelectList().then((res: any) => {
          if (res.code == 1) {
            data.formList[1].optionList = res.data.map((v: any) => {
              return { label: v.channelName, value: v.id };
            });
          }
        });
        // 连锁商户下拉框请求
        httpChannelCommissionMerchantList({
          pageNum: 0,
          pageSize: 0,
          channelId: null,
        }).then((res: any) => {
          if (res.code == 1) {
            console.log("连锁商户下拉框请求：", res);

            data.formList[2].optionList = res.data.list.map((v: any) => {
              return { label: v.merchantName, value: v.merchantId };
            });
          }
        });
      },
      changeSelect: (key: any, val: any) => {
        if (key == "channelId") {
          httpChannelCommissionMerchantList({
            pageNum: 0,
            pageSize: 0,
            channelId: val || null,
          }).then((res: any) => {
            if (res.code == 1) {
              data.formList[2].optionList = res.data.list.map((v: any) => {
                return { label: v.merchantName, value: v.id };
              });
            }
          });
        }
      },
      // 查询
      submitForm: (val: any) => {
        console.log("查询", val);
        console.log(data.formData);
        data.MyTable.tableloading = true;
        data.MyTable.selectData.channelId = val.value.channelId;
        data.MyTable.selectData.merchantId = val.value.merchantId;
        data.MyTable.selectData.orderNo = val.value.orderNo;
        data.MyTable.selectData.orderStatus = val.value.orderStatus;
        data.MyTable.selectData.startTime = data.formData.payTime[0];
        data.MyTable.selectData.endTime = data.formData.payTime[1];
        data.getTableData();
        ElMessage({
          type: "success",
          message: "查询成功！",
        });
        data.MyTable.tableloading = false;
      },
      // 导出表格
      getexportListMerchants: () => {
        httpOrderExport(data.MyTable.selectData).then((res) => {
          let link = document.createElement("a");
          let blob = new Blob([res as any], { type: "application/vnd.ms-excel" });
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.download = "分销订单列表" + new Date().getTime() + ".xls"; //下载后文件名
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
      },
      //时间表单点击事件
      formTime: (val: any) => {
        val[1] = val[1] + 3600000 * 24 - 1;
        console.log(val);
      },
      // 获取开始时间
      startTime: () => {
        data.formData.payTime[0] = new Date().setHours(0, 0, 0, 0) - 3600000 * 24 * 6;
        data.MyTable.selectData.startTime = data.formData.payTime[0];
      },
      // 获取结束时间
      endTime: () => {
        data.formData.payTime[1] = new Date().getTime();
        data.MyTable.selectData.endTime = data.formData.payTime[1];
      },
      // 禁用选择时间范围
      disabledDate: (time: Date) => {
        return time.getTime() > Date.now() || time.getTime() < Date.now() - 3600000 * 24 * 31;
      },
      //MyTable组件相关数据
      MyTable: {
        tableloading: false,
        tableData: [
          // channelCommission: 渠道每单分佣,
          // channelId: 渠道id,
          // channelName: 渠道名称,
          // createTime: 开卡时间,
          // expireTime: 到期时间,
          // fund: 维修基金,
          // fxCommission: 繁星每单分佣,
          // isCanRefund: 可否申请退款 true:可申请/false:不可申请,
          // latelyWriteOffTime: 最近核销时间,
          // merchantId: 商户id,
          // merchantName: 商户名称,
          // orderNo: 订单号,
          // orderPrice: 订单价格,
          // orderStatus: 会员卡状态：【生效中:01,已退款:02,过期:03】,
          // payTime: 订单支付时间
          // refundPeriod: 购卡后？天内可退卡,
          // refundTime: 退卡时间
          // staffId: 店员id
          // staffName: 店员名称
          // storeId: 门店id,
          // storeName: 门店名称
          // vipCardId: 会员卡Id
          // vipCardName: 会员卡名称
          // vipCardPrice: 会员卡费用,
        ], //表格数据
        //请求参数
        selectData: {
          channelId: null, //渠道id
          endTime: 0, //结束时间(时间戳)
          merchantId: "", //商户id
          orderNo: "", //订单号
          orderStatus: "", //生效中01 已退卡02 已过期03
          pageNum: 1, //当前第几页
          pageSize: 10, //每页多少条
          startTime: 0, //开始时间(时间戳)
        },
        // 表头数据
        tableColumn: [
          {
            prop: "orderNo",
            label: "卡订单号",
          },
          {
            prop: "channelName",
            label: "分销渠道",
          },
          {
            prop: "merchantName",
            label: "连锁商户",
          },
          {
            prop: "channelCommission",
            label: "渠道每单分佣",
          },
          {
            prop: "fxCommission",
            label: "繁星每单分佣",
          },
          {
            slotName: "orderStatus",
          },
          {
            prop: "createTime",
            label: "订单创建时间",
          },
          {
            prop: "expireTime",
            label: "过期/退卡时间",
          },
          {
            slotName: "vipCardName",
          },
          {
            slotName: "vipCardPrice",
          },
        ],
        //表格数据
        TotalPageTable: 0,
      },

      // 向后台请求表格数据
      getTableData: () => {
        data.MyTable.tableloading = true;
        httpOrderList(data.MyTable.selectData).then((res) => {
          console.log("请求：", data.MyTable.selectData);
          console.log("请求数据：", res);

          if (res.code) {
            let tableData = res.data.orderDTO.list;
            data.MyTable.tableData = tableData.map((v: any) => {
              v.createTime = fTime(v.createTime);
              v.expireTime = fTime(v.expireTime);
              return { ...v };
            });

            console.log("分销订单数据：", data.MyTable.tableData);
            data.MyTable.TotalPageTable = res.data.orderDTO.total;
            data.aHeader[0].text = res.data.memberNum + "人";
            data.aHeader[1].text = res.data.channelCommission;
            data.aHeader[2].text = res.data.fxCommission;
            data.MyTable.tableloading = false;
          }
        });
      },

      // 表格翻页
      handleMyTable: (val: any) => {
        data.MyTable.selectData.pageNum = val;
        data.getTableData();
      },
      // 查看会员卡详情
      seeMember: {
        // 数据
        data: [
          { label: "购买会员卡", type: "img", value: "", show: "vipCardName", money: "", time: "", src: "" },
          { label: "退卡设置", type: "text", value: "", show: "refundPeriod" },
          { label: "所属门店", type: "text", value: "", show: "storeName" },
          { label: "服务员工", type: "text", value: "", show: "staffName" },
          { label: "购买时间", type: "text", value: "", show: "createTime" },
        ],
        // 查看会员卡
        seeHandleCurrentChange: (val: any) => {
          data.guigeCurrent.value = val;
        },
        // 查看会员卡开关
        seeChannel: false,
        // 查看会员卡点击事件
        seeDialog: (msg: any) => {
          data.seeMember.data = data.seeMember.data.map((v: any) => {
            if (v.show == "vipCardName") {
              v.value = msg.vipCardName;
              v.src = msg.bgImg;
              v.money = "￥" + msg.vipCardPrice;
              v.time = "有效期" + Math.floor((Number(fTime(msg.expireTime)) - Number(fTime(msg.createTime))) / 3600000 / 24) + "天";
            }
            if (v.show == "refundPeriod") {
              if (msg.isCanRefund) {
                v.value = msg.refundPeriod > 0 ? "购卡后" + msg.refundPeriod + "天内可退卡" : "购买后有效期内可退卡";
              } else {
                v.value = "购买后不可退卡";
              }
            }
            if (v.show == "storeName") {
              v.value = msg.storeName;
            }
            if (v.show == "staffName") {
              v.value = msg.staffName;
            }
            if (v.show == "createTime") {
              v.value = msg.createTime;
            }
            return v;
          });
          console.log("选中会员卡", data.seeMember.data);
          data.seeMember.seeChannel = true;
        },
      },
      routeQuery: () => {
        const route = useRoute();
        if (Object.keys(route.query).length) {
          data.formData.channelId = Number(route.query.channelId);
          data.MyTable.selectData.channelId = route.query.channelId;
          console.log(data.formData);
        }
      },
    });
    onMounted(() => {
      data.routeQuery();
      data.startTime();
      data.endTime();
      data.getTableData();
      data.getSelection();
    });

    return {
      ...toRefs(data),
    };
  },
});
